import { Component, Input, OnInit } from '@angular/core';
import { TableConnection } from '@model/tables-plan';

@Component({
  selector: 'app-line',
  templateUrl: './line.component.html',
  styleUrl: './line.component.scss'
})
export class LineComponent implements OnInit {

  ngOnInit(): void {

  }

  @Input() set line(value: TableConnection) {
    this._line = value;
    this.updateLine();
  }

  _line!: TableConnection;
  length!: number;
  angle!: number;

  updateLine() {
    // calculate length
    const squareX = Math.pow(this._line.x2 - this._line.x1, 2);
    const squareY = Math.pow(this._line.y2 - this._line.y1, 2);

    this.length = Math.sqrt(squareX + squareY);

    // calculate angle
    const aSide = this._line.x2 - this._line.x1;
    const bSide = this._line.y2 - this._line.y1;

    const angle = (Math.atan(bSide / aSide) * 180) / Math.PI;

    this.angle = this._line.x2 > this._line.x1 ? angle : angle + 180;
  }

}
